module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_ES.f6ddbd4c.txt";